import React from 'react';
import { HeroSection } from './HeroSection';
import { PainSection } from './PainSection';
import { RulesSection } from './RulesSection';
import { OfferSection } from './OfferSection';
import { BonusesSection } from './BonusesSection';
import { FaqSection } from './FaqSection';
import { FinalCtaSection } from './FinalCtaSection';
import { SectionDivider } from './ui/SectionDivider';
export function SalesPage() {
  return <main className="min-h-screen w-full bg-brand-bg text-brand-text selection:bg-brand-gold selection:text-brand-bg" data-id="element-460">
      <HeroSection data-id="element-461" />
      <SectionDivider data-id="element-462" />

      <PainSection data-id="element-463" />
      <SectionDivider data-id="element-464" />

      <RulesSection data-id="element-465" />
      <SectionDivider data-id="element-466" />

      <OfferSection data-id="element-467" />
      <SectionDivider data-id="element-468" />

      <BonusesSection data-id="element-469" />
      <SectionDivider data-id="element-470" />

      <FaqSection data-id="element-471" />
      <SectionDivider data-id="element-472" />

      <FinalCtaSection data-id="element-473" />
    </main>;
}